import { makeStyles } from '@material-ui/core';
import { vivaTokensFor } from '../../theme';
import { VIVA_MARK } from '../icons/paths';

const useStyles = makeStyles(theme => {
  const { logo } = vivaTokensFor(theme.palette.type);
  return {
    mark: { display: 'block', width: 30, height: 30 },
    first: { stroke: logo.mark },
    second: { stroke: logo.accent },
  };
});

/**
 * Знак платформы ViVA — «Пульс»: двойная V, вторая — акцентная. Для свёрнутого сайдбара;
 * цвета из токенов темы (`logo`). Геометрия та же, что в макете айдентики.
 */
const LogoIcon = () => {
  const classes = useStyles();
  return (
    <svg className={classes.mark} viewBox="0 0 100 100" aria-hidden="true">
      <path
        className={classes.first}
        d={VIVA_MARK.first}
        fill="none"
        strokeWidth="14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={classes.second}
        d={VIVA_MARK.second}
        fill="none"
        strokeWidth="14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogoIcon;
